
import { mapState } from 'vuex'
import textTraderTitle from '~/components/textTrader/_title.vue'
export default {
  components: {
    'text-title': textTraderTitle
  },
  inject: ['info'],
  data() {
    const _pilou = this.info && this.info.safety && this.info.safety.regulatoryDisclosure && this.info.safety.regulatoryDisclosure.regulatorInfo ? this.info.safety.regulatoryDisclosure.regulatorInfo : null
    const _count = this.info && this.info.safety && this.info.safety.regulatoryDisclosure && this.info.safety.regulatoryDisclosure.total ? this.info.safety.regulatoryDisclosure.total : 0
    return {
      pilou: _pilou ? _pilou[0] : null,
      piloucount: _count
    }
  },
  computed: {
    ...mapState({
      isMobile: 'mobile'
    })
  },
  created() {},
  mounted() {
    console.log('监管披露', this.info.safety)
  },
  methods: {
    DealTraderName(content, type) {
      if (!content) {
        return ''
      }
      let ret = content
      if (type == 'text') {
        ret = ret.replace(/\{brokers name}/g, this.info.shortName)
        ret = ret.replace(/\{nom du courtier}/g, this.info.shortName)
        ret = ret.replace(/\{0}/g, this.info.shortName)
      } else {
        ret = ret.replace('{brokers name}', `<a class="trader" href="${this.getwwwDomain(this.$store.state)}/${this.$store.state.LanguageCode}/dealer/${this.info.traderCode}.html" target="_blank">${this.info.shortName}</a>`)
        ret = ret.replace(/\{brokers name}/g, this.info.shortName)
        ret = ret.replace('{nom du courtier}', `<a class="trader" href="${this.getwwwDomain(this.$store.state)}/${this.$store.state.LanguageCode}/dealer/${this.info.traderCode}.html" target="_blank">${this.info.shortName}</a>`)
        ret = ret.replace(/\{nom du courtier}/g, this.info.shortName)
        ret = ret.replace('{0}', `<a class="trader" href="${this.getwwwDomain(this.$store.state)}/${this.$store.state.LanguageCode}/dealer/${this.info.traderCode}.html" target="_blank">${this.info.shortName}</a>`)
        ret = ret.replace(/\{0}/g, this.info.shortName)
      }
      return ret
    },
    ALB() {
      return this.$store.state.LanguageCode == 'ar' ? 'ALB' : ''
    }
  }
}
